$(".header__icon--cart:not(.header_b2b)").click(function (e) {
  e.preventDefault();
  openCart();
});

$(".drawer-overlay, .toggle-drawer").click(function () {
  console.log("close");
  closeCart();
});

function openCart() {
  $("body").addClass("body-overflow-hidden");
  $("#ajax-drawer").addClass("drawer-open");
}
function closeCart() {
  $("body").removeClass("body-overflow-hidden");
  $("#ajax-drawer").removeClass("drawer-open");
}
function quantityCounter() {
  $(document).on("click", "#q_up", function () {
    var C = $(this).attr("data-id"),
      S = parseInt($(this).siblings(".quantity-cart-" + C).val()) + 1,
      M = parseInt($(this).prev("input").attr("maxLength"));
    if(S > M) {
      $(this).attr("data-quantity", M);
    }
    $(this)
      .siblings(".quantity-cart-" + C)
      .val(S);
  }),
    $(document).on("click", "#q_down[data-quantity!='0']", function () {
      var C = $(this).attr("data-id"),
        S = parseInt(
          $(this)
            .siblings(".quantity-cart-" + C)
            .val()
        );
      0 < S && $(this).attr("data-quantity", S - 1);
      0 < S &&
        $(this)
          .siblings(".quantity-cart-" + C)
          .val(S - 1);
    });
}
function quantityCounterColl() {
  $(document).on("click", "#add-cart .q_up", function () {
    var C = $(this).attr("data-id"),
      S =
        parseInt(
          $(this)
            .siblings(".quantity-cart-" + C)
            .val()
        ) + 1;
    $(this).attr("data-quantity", S);
    $(this)
      .siblings(".quantity-cart-" + C)
      .val(S);
    openCart();
  }),
    $(document).on("click", "#add-cart .q_down", function () {
      var C = $(this).attr("data-id"),
        S = parseInt(
          $(this)
            .siblings(".quantity-cart-" + C)
            .val()
        );
      0 < S && $(this).attr("data-quantity", S - 1);
      0 < S &&
        $(this)
          .siblings(".quantity-cart-" + C)
          .val(S - 1);
      openCart();
    });
}

function quantityCounterHoneymoon() {
  $(document).on("click", "#q_up-honeymoon", function () {
    var C = $(this).attr("data-id"),
      S =
        parseInt(
          $(this)
            .siblings(".quantity-cart-" + C)
            .val()
        ) + 2;
    $(this).attr("data-quantity", S);
    $(this)
      .siblings(".quantity-cart-" + C)
      .val(S);
  }),
    $(document).on("click", "#q_down-honeymoon", function () {
      var C = $(this).attr("data-id"),
        S = parseInt(
          $(this)
            .siblings(".quantity-cart-" + C)
            .val()
        );
      0 < S && $(this).attr("data-quantity", S - 2);
      0 < S &&
        $(this)
          .siblings(".quantity-cart-" + C)
          .val(S - 2);
    });
}

function convertToRupiah(angka) {
  var rupiah = "";
  angka = angka.toString();
  angka = angka.substring(0, angka.length - 2);
  var angkarev = angka.toString().split("").reverse().join("");
  for (var i = 0; i < angkarev.length; i++)
    if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
  return (
    "Rp " +
    rupiah
      .split("", rupiah.length - 1)
      .reverse()
      .join("")
  );
}

function editCart() {
  $(document).on("click", ".change-cart:not(.disabled)", function (y) {
    y.preventDefault();
    var C = $(this),
      newQuantity = parseInt(C.attr("data-quantity")),
      S = C.attr("data-id"),
      parent = $("#item-" + S);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + newQuantity + "&id=" + S,
      dataType: "json",
      beforeSend: function () {
        // cart operation
        parent.addClass("loading");
      },
      success: function (E) {
        // Update cart number
        var B = $(".np-cart-badge");
        B.text(E.item_count);
        B.attr("title", E.item_count);

        updateDrawerNonLangganan();
        //updateDrawerLangganan();
        //updateFloatingCart(E.total_price);

        $("input.quantity-cart-" + S).val(newQuantity);
        0 == newQuantity
          ? (parent.remove(),
            $("#counter-" + S).addClass("dn"),
            $("#form-" + S).removeClass("dn"))
          : parent.removeClass("loading");
      },
      error: function (I, P) {
        console.log("Error occured while editing cart");
      },
    });
  });
}

// BELANJA
function belanjaAddToCart() {
  $(document).on("click", ".add-to-cart:not(.disabled)", function () {
    var y = $(this),
      S = y.closest("form"),
      id = $(this).attr("data-id"),
      id = $(this).attr("data-id"),
      title = S.find(".data-title").val(),
      vendor = S.find(".data-vendor").val(),
      image = S.find(".data-image").val();
    return (
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        cache: !1,
        data: S.serialize(),
        dataType: "json",
        beforeSend: function () {
          y.text("Menambah..");
        },
        complete: function () {
          y.text("Beli Sekarang");
          $("input.quantity-cart-" + id).val("1");
          S.addClass("dn");
          S.siblings("#counter-" + id).removeClass("dn");
        },
        error: function (T) {
          updateCart(T, !1);
        },
        success: function (T) {
          // Add only return one single json
          var B = $(".np-cart-badge");
          var count = parseInt(B.attr("title")) + 1;
          B.text(count);
          B.attr("title", count);
          y.hasClass("drawer") &&
            ($("form#form-" + id).addClass("dn"),
            $("#counter-" + id).removeClass("dn"));
          updateDrawerNonLangganan();
          updateCart(T, !0);
          var P = "#shopify-section-floating-bottom";
          $(P).fadeIn().delay(5000).fadeOut();
          $(".content-floatingCart").find("img").attr("src", image);
          $(".content-floatingCart").find(".title").text(title);
          $(".content-floatingCart").find(".brand").text(vendor);
        },
      }).done(function () {}),
      !1
    );
  });
}
function belanjaAddToCartColl() {
  $(document).on("click", ".add-cart:not(.disabled)", function () {
    var y = $(this),
      S = y.closest("form"),
      q = y.closest("form").find(".quantity__input").val(),
      d = y.closest("form").find("[name='id']").val(),
      id = $(this).attr("data-id"),
      p = y.closest("form").find("[name='properties']").val(),
      title = S.find(".data-title").val(),
      vendor = S.find(".data-vendor").val(),
      image = S.find(".data-image").val(),
      isB2b = $(".isB2b");
    // var properties =
    return (
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        cache: !1,
        data: "quantity=" + q + "&id=" + d,
        dataType: "json",
        beforeSend: function () {
          y.text("Menambahkan...");
        },
        complete: function () {
          y.text("+ Keranjang");
          y.closest("form").find(".quantity__input").val(1);
          $("input.quantity-cart-" + id).val(parseInt(q));
          S.addClass("dn");
          S.siblings("#counter-" + id).removeClass("dn");
        },
        error: function (T) {
          if(T.status === 422) {
            alert(T.responseJSON.description)
          }
          updateCart(T, !1);
        },
        success: function (T) {
          console.log(isB2b.val());
          if (isB2b.val() != undefined) {
            return window.location.replace("https://favo.id/cart");
          }
          // Add only return one single json
          var B = $(".np-cart-badge");
          var C = $(".np-cart-total").attr("data-price");
          var count = parseInt(B.attr("title")) + parseInt(q);
          B.text(count);
          B.attr("title", count);
          y.hasClass("drawer") &&
            ($("form#form-" + id).addClass("dn"),
            $("#counter-" + id).removeClass("dn"));
          $(".progress-fill").attr("data-price", C);
          updateDrawerNonLangganan();
          updateCart(T, !0);
          var P = "#shopify-section-floating-bottom";
          $(P).fadeIn().delay(5000).fadeOut();
          $(".content-floatingCart").find("img").attr("src", image);
          $(".content-floatingCart").find(".title").text(title);
          $(".content-floatingCart").find(".brand").text(vendor);
        },
      }).done(function () {}),
      !1
    );
  });
}
function belanjaAddToCartCollB2b() {
  $(document).on("click", ".add-cart-b2b:not(.disabled)", function () {
    var y = $(this),
      S = y.closest("form"),
      q = y.closest("form").find(".quantity__input").val(),
      d = y.closest("form").find("[name='id']").val(),
      id = $(this).attr("data-id"),
      p = y.closest("form").find("[name='properties']").val(),
      title = S.find(".data-title").val(),
      vendor = S.find(".data-vendor").val(),
      image = S.find(".data-image").val(),
      isB2b = $(".isB2b");
    // var properties =
    return (
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        cache: !1,
        data: S.serialize(),
        dataType: "json",
        beforeSend: function () {
          y.text("Menambahkan...");
        },
        complete: function () {
          y.text("+ Keranjang");
          y.closest("form").find(".quantity__input").val(1);
          $("input.quantity-cart-" + id).val(parseInt(q));
          S.addClass("dn");
          S.siblings("#counter-" + id).removeClass("dn");
        },
        error: function (T) {
          updateCart(T, !1);
        },
        success: function (T) {
          console.log(isB2b.val());
          if (isB2b.val() != undefined) {
            return window.location.replace("https://favo.id/cart");
          }
          // Add only return one single json
          var B = $(".np-cart-badge");
          var C = $(".np-cart-total").attr("data-price");
          var count = parseInt(B.attr("title")) + parseInt(q);
          B.text(count);
          B.attr("title", count);
          y.hasClass("drawer") &&
            ($("form#form-" + id).addClass("dn"),
            $("#counter-" + id).removeClass("dn"));
          $(".progress-fill").attr("data-price", C);
          updateDrawerNonLangganan();
          updateCart(T, !0);
          var P = "#shopify-section-floating-bottom";
          $(P).fadeIn().delay(5000).fadeOut();
          $(".content-floatingCart").find("img").attr("src", image);
          $(".content-floatingCart").find(".title").text(title);
          $(".content-floatingCart").find(".brand").text(vendor);
        },
      }).done(function () {}),
      !1
    );
  });
}
function belanjaAddToCartCollMobile() {
  $(document).on("click", ".add-cart-mobile:not(.disabled)", function () {
    var y = $(this),
      S = y.closest("form"),
      q = y.closest("form").find(".quantity__input").val(),
      d = y.closest("form").find("[name='id']").val(),
      id = $(this).attr("data-id"),
      title = S.find(".data-title").val(),
      vendor = S.find(".data-vendor").val(),
      image = S.find(".data-image").val();
    return (
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: !0,
        cache: !1,
        data: {
          quantity: parseInt(q),
          id: d,
        },
        dataType: "json",
        beforeSend: function () {
          y.text("Menambahkan...");
        },
        complete: function () {
          y.text("+ Keranjang");
          y.closest("form").find(".quantity__input").val(1);
          $("input.quantity-cart-" + id).val(parseInt(q));
          S.addClass("dn");
          S.siblings("#counter-" + id).removeClass("dn");
        },
        error: function (T) {
          updateCart(T, !1);
        },
        success: function (T) {
          // Add only return one single json
          var B = $(".np-cart-badge");
          var C = $(".np-cart-total").attr("data-price");
          var count = parseInt(B.attr("title")) + parseInt(q);
          B.text(count);
          B.attr("title", count);
          y.hasClass("drawer") &&
            ($("form#form-" + id).addClass("dn"),
            $("#counter-" + id).removeClass("dn"));
          $(".progress-fill").attr("data-price", C);
          updateDrawerNonLangganan();
          updateCart(T, !0);
          var P = "#shopify-section-floating-bottom";
          $(P).fadeIn().delay(5000).fadeOut();
          $(".content-floatingCart").find("img").attr("src", image);
          $(".content-floatingCart").find(".title").text(title);
          $(".content-floatingCart").find(".brand").text(vendor);
        },
      }).done(function () {}),
      !1
    );
  });
}
function belanjaEditCart() {
  $(document).on("click", ".belanja-cart:not(.disabled)", function (y) {
    y.preventDefault();
    var C = $(this),
      newQuantity = parseInt(C.attr("data-quantity")),
      S = C.attr("data-id"),
      parent = $("#item-" + S);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + newQuantity + "&id=" + S,
      dataType: "json",
      beforeSend: function () {},
      success: function (E) {
        // Update cart number
        var B = $(".np-cart-badge");
        B.text(E.item_count);
        B.attr("title", E.item_count);
        openCart();
        //0 == E.total_price && ($('#shopify-section-floating-bottom').empty(), $('#shopify-section-floating-bottom').addClass('dn'));
        0 == newQuantity &&
          ($("#counter-" + S).addClass("dn"),
          $("#form-" + S).removeClass("dn"));

        // Updating ajax drawer
        updateDrawerNonLangganan();
        if (E.total_price != 0) {
          // Updating floating cart
          $.ajax({
            url: "/search?view=cart",
            beforeSend: function () {},
            success: function (I) {
              //var P = "#shopify-section-floating-bottom";
              //$(P).html($(I).filter(P).html());
              //$(P).fadeIn().delay(5000).fadeOut();
            },
            error: function (I) {
              console.log(I);
            },
          }).done(function () {});
        } else {
          $("#non-langganan-list").empty();
        }
      },
      error: function (I, P) {
        console.log("Error occured while editing cart");
      },
    });
  });
}
function updateCart(y, C) {
  if (!0 == C)
    $.ajax({
      url:
        "/search?view=cart&q=" +
        y.handle +
        "_" +
        y.variant_id +
        "_" +
        y.quantity +
        "_" +
        y.price,
      beforeSend: function () {},
      success: function (T) {
        //var P = "#shopify-section-floating-bottom";
        //$(P).html($(T).filter(P).html());
        //$(P).fadeIn().delay(5000).fadeOut();
      },
      error: function (T) {
        console.log(T);
      },
    });
  else {
    var S = $.parseJSON(y.responseText);
    $.ajax({
      url: "/search?view=cart_error&q=" + S.description,
      beforeSend: function () {},
      success: function (T) {
        var I = "div#cart_error_popup";
        $(I).html($(T).filter(I).html());
      },
      error: function (T) {
        console.log(T);
      },
    }).done(function () {
      var T = (i = $.parseJSON(y.responseText)),
        I = T.message + ": " + T.description;
    });
  }
}

// AJAX DRAWER
function drawerEditCart() {
  $(document).on("click", ".drawer-cart[data-quantity!='0']", function (y) {
    y.preventDefault();
    var C = $(this),
      newQuantity = parseInt(C.attr("data-quantity")),
      S = C.attr("data-id"),
      parent = $("#item-" + S);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + newQuantity + "&id=" + S,
      dataType: "json",
      beforeSend: function () {
        // cart operation
        parent.addClass("loading");
      },
      success: function (E) {
        // Update cart number
        var B = $(".np-cart-badge");
        B.text(E.item_count);
        B.attr("title", E.item_count);
        $("input.quantity-cart-" + S).val(newQuantity);
        0 == newQuantity
          ? (parent.remove(),
            $("#counter-" + S).addClass("dn"),
            $("#form-" + S).removeClass("dn"))
          : parent.removeClass("loading");
        0 == E.total_price && $("#shopify-section-floating-bottom").empty();

        // Updating ajax drawer
        //updateDrawerLangganan();
        updateDrawerNonLangganan();
        //updateFloatingCart(E.total_price);

        // Updating other element in the page.
        // quantity-cart-29291365269601
        // quantity-cart-29291365269601
      },
      error: function (e) {
        console.log(e);
        parent.removeClass("loading");
        if (e?.status === 422) {
          parent.find("[name=quantity]").val(newQuantity - 1);
          alert(e.responseJSON.message);
        }
      },
    });
  });
}

function drawerEditCartPage() {
  $(document).on(
    "click",
    ".drawer-cart-page[data-quantity]",
    function (y) {
      y.preventDefault();
      var C = $(this),
        newQuantity = parseInt(C.attr("data-quantity")),
        S = C.attr("data-id"),
        i = C.attr("data-index"),
        parent = $("#CartItem-" + i);
      console.log(newQuantity)
      if(newQuantity === 0) {
        // console.log("removed")
        // parent.find("cart-remove-button a").click()
        // location.reload()
      }
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + newQuantity + "&line=" + i,
        dataType: "json",
        beforeSend: function () {
          // cart operation
          parent.addClass("loading");
        },
        success: function (E) {
          // Update cart number
          var B = $(".np-cart-badge");
          B.text(E.item_count);
          B.attr("title", E.item_count);
          $(".quantity-input[data-index="+ i +"]").val(newQuantity);
          0 == newQuantity
            ? (parent.remove(),
              $("#counter-" + S).addClass("dn"),
              $("#form-" + S).removeClass("dn"))
            : parent.removeClass("loading");
          0 == E.total_price && $("#shopify-section-floating-bottom").empty();
          updateCartPage();
          updateCartPage2();
          if($(".np-cart-badge").text() == "0") {
            location.reload();
          }
        },
        error: function (I) {
          console.log(I);
        },
      });
    }
  );
}

function updateCartPage() {
  $.ajax({
    url: "/cart?view=ajax",
    success: function (J) {
      var cart = "cart-items#cart";
      $(cart).html($(J).filter(cart).html());
    },
    error: function (J) {
      console.log(I);
    },
  }).done(function () {});
}

function updateCartPage2() {
  $.ajax({
    url: "/cart?view=ajax2",
    success: function (J) {
      var cart = "#totals ";
      $("#totals").html($(J).filter("#totals").html());
    },
    error: function (J) {
      console.log(I);
    },
  }).done(function () {});
}

// CART
function cartCheckout() {
  // Function only process date and note from non-langganan product
  $(document).on("click", ".checkout-process:not(.disabled)", function (y) {
    y.preventDefault();
    var C = $(this);
    var S = $("form#cartAttribute");
    return (
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        async: !0,
        cache: !1,
        data: S.serialize(),
        dataType: "json",
        beforeSend: function () {
          C.text("Sedang memproses..");
        },
        complete: function () {},
        error: function (T) {
          console.log(T);
        },
        success: function (T) {
          var urlNext = C.attr("href");
          window.location.replace(urlNext);
        },
      }).done(function () {}),
      !1
    );
  });
}

function updateDrawerNonLangganan() {
  var drawer = $("#ajax-drawer");
  $.ajax({
    url: "/search?view=ajax-drawer",
    beforeSend: function () {
      drawer.addClass("loading");
    },
    success: function (J) {
      var nonLanggananList = "div#non-langganan-list";
      $(nonLanggananList).html($(J).filter(nonLanggananList).html());
      var drawerFooter = "div#drawer-footer";
      $(drawerFooter).html($(J).filter(drawerFooter).html());
      var countNonLangganan = $(J)
        .filter(nonLanggananList)
        .find(".each-cart-item").length;
      //1 <= countNonLangganan ? $('#cartAttribute .non-langganan').removeClass('dn') : $('#cartAttribute .non-langganan').addClass('dn');
    },
    error: function (J) {
      console.log(I);
    },
  }).done(function () {
    drawer.removeClass("loading");
    openCart();
  });
}
/*
function updateFloatingCart(price){
if (price != 0 ) {
    $.ajax({
    url: "/search?view=cart",
    beforeSend: function() {},
    success: function(I) {
        var P = "#shopify-section-floating-bottom";
        $(P).html($(I).filter(P).html());
        $(P).fadeIn().delay(5000).fadeOut();
    },
    error: function(I) {
        console.log(I)
    }
    }).done(function() {})
} else {
    $('#shopify-section-floating-bottom').empty();
}
}
*/

$("#shopify-section-floating-bottom .overlay, .close-floatingCart").click(
  function () {
    $("#shopify-section-floating-bottom").hide();
  }
);

quantityCounter();
quantityCounterColl();
quantityCounterHoneymoon();
editCart();

belanjaAddToCart();
belanjaAddToCartColl();
belanjaAddToCartCollB2b();
belanjaAddToCartCollMobile();
//belanjaAddToCartMobile();
belanjaEditCart();

drawerEditCart();
drawerEditCartPage();
// drawerEditCartPage2();

cartCheckout();
